import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import format from 'format-number'
import { Button } from '@mui/material';

const columns = [
  { id: 'indice', label: '', width: 15, align: 'center' },
  { id: 'fecha', label: 'Fecha', width: 150, align: 'center' },
  { id: 'rutaPDF', label: 'Documentos PDF', width: 150, align: 'center' },
  { id: 'rutaXML', label: 'Documentos XML', width: 150, align: 'center' },
  { id: 'monto', label: 'Monto', width: 150, align: 'right' },
];



export default function ComprobantesRegistradosViaticosListado(props) {
  const { facturasRegistradas, setFacturasRegistradas} = props
  let total = Number(0)
  const colocarNombre = (ruta) => {
    if(!ruta || ruta==='')
            return ''
    const indice = Number(ruta.indexOf("factura")) + 9
    return ruta.slice(indice)

  }
  const handleDelete = async (registro) => {
    //console.log(`registro ${JSON.stringify(registro)}`)
    // borrar las facturas registradas 
    try {
      let tipoFacturaBorrar;
      if (registro.idViaticos)
        tipoFacturaBorrar = `http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/facturaComprobante/${registro.id}`
      if (registro.idValeCaja)
        tipoFacturaBorrar = `http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/facturaValeCaja/${registro.id}`
      if (registro.idGastosViaje)
        tipoFacturaBorrar = `http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/facturaGastosViaje/${registro.id}`
      if (registro.idAsistenciaEventos)
        tipoFacturaBorrar = `http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/facturaAsistenciaEventos/${registro.id}`
      if (registro.idConferencianteInvitado)
        tipoFacturaBorrar = `http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/facturaConferencianteInvitado/${registro.id}`

      await fetch(tipoFacturaBorrar, {
        method: "DELETE",
        headers: {
          "x-access-token": sessionStorage.getItem('token'),
          "perfil": sessionStorage.getItem('perfil')
        }
      })
      
      setFacturasRegistradas(facturasRegistradas.filter(facturas => facturas.id !== registro.id))
    } catch (error) {
      console.error(error)
    }
  }
  return (
    <Paper sx={{ width: '100%', marginTop: 5 }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow key='encabezado'>
              <TableCell key='ninguna' align="center" colSpan={6}>
                Comprobantes registrados
              </TableCell>
            </TableRow>
            <TableRow key='encabezado2'>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ top: 57, minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>

              ))}
              <TableCell style={{ top: 57 }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              facturasRegistradas && facturasRegistradas.length > 0 ? facturasRegistradas
                .map((row, index) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.indice}>
                      {
                        columns.map((column) => {
                          const value = row[column.id];
                          if (column.id === 'monto')
                            total = Number(total) + Number(value)
                          // console.log(`column.id ${column.id} row[column.id] ${row[column.id]}`)                    
                          return (
                            <TableCell key={column.id} align={column.align} style={{ whiteSpace: 'pre' }}>
                              {column.id === 'fecha' ? (value ? (new Date(value)).toLocaleString('es-MX', { day: "2-digit", month: "short", year: "numeric" }):'') :
                                column.id === 'monto' ? format({ prefix: '$' })(value) :
                                  column.id === 'rutaPDF' ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoPDF/${colocarNombre(value)}`} download={colocarNombre(value)}>{colocarNombre(value)}</Button> :
                                    column.id === 'rutaXML' ? (value ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoXML/${colocarNombre(value)}`} download={colocarNombre(value)}>{colocarNombre(value)}</Button> : '') : ''
                              }

                            </TableCell>
                          );
                        })}
                      <TableCell><Button variant='contained' style={{ marginLeft: 5, backgroundColor: "darkred", color: 'white' }} onClick={() => handleDelete(row)}>{'Eliminar'}</Button></TableCell>
                    </TableRow>
                  );
                }) : <TableRow hover role="checkbox" tabIndex={-1} >

                <TableCell align='center'>
                  No hay comprobantes registrados
                </TableCell>

              </TableRow>}
            {facturasRegistradas && facturasRegistradas.length > 0 ? <TableRow hover role="checkbox" tabIndex={-1} >

              <TableCell align='center' colSpan={3}>

              </TableCell>
              <TableCell align='right'>
                <strong>Total: {format({ prefix: '$' })(total)}</strong>
              </TableCell>

            </TableRow> : <></>}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}